/** The page where a patient turns the practice's advertising trackers off, signed in or not. */
export const PRIVACY_CHOICES_PATH = "/privacy-choices";

/** The same choice inside the account area, where the signed-in patient's account saves it. */
export const ACCOUNT_PRIVACY_CHOICES_PATH = "/account/privacy";
